var exports = {
  "F": "x04b3a21e--f79a5a--link-container",
  "n": "x04b3a21e--f79a5a--link",
};

module.exports = exports;
